type Coords = { lat: number; lng: number } | null | undefined;

export interface DeliveryUrlFields {
  homeDeliverySelected?: boolean;
  homeReturnSelected?: boolean;
  homeDeliveryAddress?: string;
  homeReturnAddress?: string;
  deliveryCoordinates?: Coords;
  returnCoordinates?: Coords;
  homeDeliveryAddressKm?: number;
  homeReturnAddressKm?: number;
}

const DELIVERY_SESSION_KEY = "deliveryDetails";

export function encodeDeliveryUrlParams(
  e: DeliveryUrlFields
): Record<string, string> {
  const params: Record<string, string> = {};
  if (e.homeDeliverySelected) {
    params.homeDeliverySelected = "true";
    if (e.homeDeliveryAddressKm != null)
      params.homeDeliveryAddressKm = String(e.homeDeliveryAddressKm);
  }
  if (e.homeReturnSelected) {
    params.homeReturnSelected = "true";
    if (e.homeReturnAddressKm != null)
      params.homeReturnAddressKm = String(e.homeReturnAddressKm);
  }
  return params;
}

export function persistDeliveryDetails(e: DeliveryUrlFields): void {
  try {
    if (!e.homeDeliverySelected && !e.homeReturnSelected) {
      sessionStorage.removeItem(DELIVERY_SESSION_KEY);
      return;
    }
    sessionStorage.setItem(
      DELIVERY_SESSION_KEY,
      JSON.stringify({
        homeDeliveryAddress: e.homeDeliveryAddress ?? "",
        homeReturnAddress: e.homeReturnAddress ?? "",
        deliveryCoordinates: e.deliveryCoordinates ?? null,
        returnCoordinates: e.returnCoordinates ?? null,
      })
    );
  } catch {
    console.warn("persistDeliveryDetails: sessionStorage write failed");
  }
}

const readDeliveryDetailsFromSession = (): Partial<DeliveryUrlFields> => {
  try {
    const raw = sessionStorage.getItem(DELIVERY_SESSION_KEY);
    return raw ? (JSON.parse(raw) as Partial<DeliveryUrlFields>) : {};
  } catch {
    return {};
  }
};

const parseKm = (v: string | null): number | undefined =>
  v != null && v !== "" && Number.isFinite(Number(v)) ? Number(v) : undefined;

export function decodeDeliveryUrlParams(
  searchParams: URLSearchParams
): Required<
  Pick<DeliveryUrlFields, "homeDeliverySelected" | "homeReturnSelected">
> &
  DeliveryUrlFields {
  const homeDeliverySelected =
    searchParams.get("homeDeliverySelected") === "true";
  const homeReturnSelected = searchParams.get("homeReturnSelected") === "true";
  const session =
    homeDeliverySelected || homeReturnSelected
      ? readDeliveryDetailsFromSession()
      : {};
  return {
    homeDeliverySelected,
    homeReturnSelected,
    homeDeliveryAddress: session.homeDeliveryAddress ?? "",
    homeReturnAddress: session.homeReturnAddress ?? "",
    deliveryCoordinates: session.deliveryCoordinates ?? null,
    returnCoordinates: session.returnCoordinates ?? null,
    homeDeliveryAddressKm: parseKm(searchParams.get("homeDeliveryAddressKm")),
    homeReturnAddressKm: parseKm(searchParams.get("homeReturnAddressKm")),
  };
}
